import {
  Required,
  IsString,
  DataValidator,
  transformKeys,
} from "@/utils/type-vaildator";
import api from "./api";

interface ActorFilterOptionsResponse {
  category_keys: {
    [key: string]: string
  };
  filter_options: {
    [key: string]: {
      label: string;
      value: string;
    }[];
  };
}

// 过滤选项项类
export class FilterOptionItem {
  @Required("Label cannot be empty")
  @IsString("Label must be a string")
  label: string;

  @Required("Value cannot be empty")
  @IsString("Value must be a string")
  value: string;
}

// 主数据类
export class ActorFilterOptionsData {
  @Required("Filter options category cannot be empty")
  categoryKeys: { [key: string]: string };
  @Required("Filter options cannot be empty")
  filterOptions: {
    [key: string]: FilterOptionItem[];
  };
}

const transformAndValidateActorFilterOptions = (
  response: ActorFilterOptionsResponse
): ActorFilterOptionsData => {
  const transformedData = transformKeys(response);

  try {
    // 先验证主对象
    const mainData = DataValidator.validateOrThrow(
      transformedData,
      ActorFilterOptionsData
    );
    // 手动验证 categoryKeys 中的每个键值对
    if (mainData.categoryKeys) {
      for (const [key, value] of Object.entries(mainData.categoryKeys)) {
        if (typeof key !== "string" || typeof value !== "string") {
          throw new Error("Category key must be a string");
        }
      }
    }
    // 手动验证 filterOptions 中的每个数组和数组项
    if (mainData.filterOptions) {
      for (const items of Object.values(mainData.filterOptions)) {
        if (Array.isArray(items)) {
          for (const item of items) {
            DataValidator.validateOrThrow(item, FilterOptionItem);
          }
        } else {
          throw new Error("Filter option value must be an array");
        }
      }
    }

    return mainData;
  } catch (error) {
    console.error(
      "Actor filter options data validation failed:",
      error.message
    );
    throw error;
  }
};

const URL = "/actor/filter-options";

export const actorFilterOptions = async (): Promise<ActorFilterOptionsData> => {
  const response = await api.get<ActorFilterOptionsResponse>(URL);
  const validatedData = transformAndValidateActorFilterOptions(response.data);
  return validatedData;
};
